import { render, staticRenderFns } from "./background.vue?vue&type=template&id=20010c1a&scoped=true"
var script = {}
import style0 from "./background.vue?vue&type=style&index=0&id=20010c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20010c1a",
  null
  
)

export default component.exports